var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"animated-decimal-number"},[_c('animated-number',{attrs:{"value":_vm.integerPart}}),_c('span',{staticClass:"decimal"},[_vm._v("."),_c('animated-number',{attrs:{"value":_vm.decimalPart}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b84883","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/AnimatedDecimalNumber.vue
// module id = null
// module chunks = 